import { changeCountry, updateGlobalECountry } from "../../shop/connect";
import displayModal from "../../util/modal";
import { reloadGECheckout } from "../../components/global-e";
import { handleCountryChange as updatePfasCountry } from "../../components/pfas";
var country = function country() {
  // Custom dropdown
  $(".js-dropdownFlag--country .cart-dropdown-item").on("click", function (e) {
    e.preventDefault();
    var selectedCountry = e.currentTarget.dataset.value;
    var disabledLinkButton = $(document).find('.js-disabledOnClick button');
    if (disabledLinkButton.length) {
      disabledLinkButton.addClass('is-loading disabled');
      disabledLinkButton.prop('disabled', true);
    }
    changeCountry(selectedCountry).then(function () {
      updatePfasCountry(selectedCountry);
      reloadGECheckout();
    });
  });
};
var countryModal = function countryModal() {
  if ($("#js-countrySelectorModal").length === 0) return;
  var modalEl = $("#js-countrySelectorModal");
  var dropdownCountry = modalEl.find(".js-dropdown--country");
  if (dropdownCountry.length > 0) {
    dropdownCountry.on("click", function (e) {
      e.preventDefault();
      var selected = $(e.currentTarget);
      modalEl.find(".js-dropdown--country").removeClass('active');
      modalEl.find("#countrySelector").text(selected.text());
      selected.addClass("active");
    });
  }
  var submitBtn = modalEl.find(".js-continue");
  if (submitBtn.length > 0) {
    submitBtn.on("click", function (e) {
      var btn = $(e.currentTarget);
      btn.addClass("is-loading");
      var country = getSelectedOption(modalEl, ".js-dropdown--country");
      if (country) {
        changeCountry(country).then(function () {
          updatePfasCountry(country);
          btn.removeClass("is-loading");
        });
      } else {
        setTimeout(function () {
          btn.removeClass("is-loading");
        }, 500);
      }
    });
  }
};
var getSelectedOption = function getSelectedOption(modalEl, selector) {
  if (modalEl.length === 0) return;
  var el = modalEl.find("".concat(selector, ".active"));
  var val;
  if (el.length > 0) val = el.data('code');
  return val;
};
var displayCountryModal = function displayCountryModal() {
  displayModal("js-countrySelectorModal", "country_modal");
  countryModal();
};
export default country;
export { displayCountryModal };


// WEBPACK FOOTER //
// ./scripts/partials/top/country.js